import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    gridContainer: {
        width: "90%",
        margin: "0 auto",
        display: "flex",
        justifyContent: "space-between",
        padding: theme.spacing(2, 3),
    },
    gridBoxShadow: {
        boxShadow: "0px 4px 0px rgba(62, 93, 138, 0.2)",
    },
    leftGrid: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-end",
    },
    rightGrid: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
    },
}));
